import { useContext } from "react";
import { Layout, CompareAndSelect } from "@vwfs-bronson/bronson-react";
import { SVGDesgaste } from "../../Svgs/SVGDesgaste";
import { SVGMantenimiento } from "../../Svgs/SVGMantenimiento";
// import { percentageDifference } from "../../../helpers/percentageDifference";
import { MantenimientoStandAloneShowMore } from "./MantenimientoStandAloneShowMore";
import { useAddictionalProducts } from "../../../hooks/useAddictionalProducts";
import { useLocationVehicle } from "../../../hooks/useLocationVehicle";
import { useDispatch } from "react-redux";
import { setSelectedMantenimentoStandAlone } from "../../../actions/summaryAction";
import { useEffect } from "react";
import { getMantenimientoLDStandAlone, setMantenimientoStandAlone } from "../../../actions/addictionalProductsAction";
import { validateMantenimientoIcon } from "../../../validators/validateMantenimientoIcon";
import { validateDesgasteIcon } from "../../../validators/validateDesgasteIcon";
import { WizardConext } from "../../../contexts/WizardContext";
import { currencyFormat } from "../../../helpers/currencyFormat";
import { financialFormat } from "../../../helpers/financialFormat";
import { getIVAText } from "../../../helpers/getIVAText";

export const MantenimientoStandAlone = () => {
    const { mantenimientoStandAlone } = useAddictionalProducts();
    const { OutOfWindowAction } = useContext(WizardConext);
    const locationVehicle = useLocationVehicle();
    const dispatch = useDispatch();

    const removeSelected = ({ ParentCode }) => {
        mantenimientoStandAlone?.MantenimientoLD?.Mantenimientos.forEach((x) => {
            if (!ParentCode) {
                const value = document.getElementsByName("button-group-item-MT_" + x.Codigo);
                value.forEach((v) => (v.checked = false));
            }
            if (x.Codigo !== ParentCode) {
                const value = document.getElementsByName("button-group-item-MT_" + x.Codigo);
                value.forEach((v) => (v.checked = false));
            }

            Object.keys(x.Paquetes).forEach(function (key) {
                x.Paquetes[key].Selected = false;
            });
        });
    };

    const setSelected = async (paq) => {
        if (!paq) {
            console.error("[MANTENIMIENTO] No se ha podido resolver el paquete seleccionado");
            return;
        }

        removeSelected(paq);
        const mantSelected = mantenimientoStandAlone?.MantenimientoLD?.Mantenimientos.filter(
            (x) => x.Codigo == paq.Codigo
        );
        const index = mantSelected?.[0]?.Paquetes.findIndex(
            (x) => x.Codigo === paq.Codigo && x.Key == paq.Key
        );

        if (!mantSelected?.[0] || index == null || index < 0) {
            console.error("[MANTENIMIENTO] Paquete no encontrado", paq);
            return;
        }

        mantSelected[0].Paquetes[index].Selected = true;
        dispatch(setSelectedMantenimentoStandAlone(mantSelected[0]));
        // TODO: Mirar que es necesario dispatch(checkClientInfotStep());
        requestAnimationFrame(() => {
            document.getElementById("NextButton")?.scrollIntoView({ block: "center" });
        });
    };

    const resolveSelectedPackage = (packages, maintenanceCode, eventOrValue, callbackValue) => {
        const candidates = [
            callbackValue?.index,
            callbackValue?.selectedIndex,
            callbackValue?.value,
            callbackValue?.target?.value,
            callbackValue?.currentTarget?.value,
            eventOrValue?.index,
            eventOrValue?.selectedIndex,
            eventOrValue?.value,
            eventOrValue?.target?.value,
            eventOrValue?.currentTarget?.value,
            callbackValue,
            eventOrValue,
        ];

        for (const candidate of candidates) {
            if (candidate === undefined || candidate === null || typeof candidate === "object") {
                continue;
            }

            const packageByKey = packages?.find(
                (paq) => String(paq.Key) === String(candidate)
            );
            if (packageByKey) return packageByKey;

            const selectedIndex = Number(candidate);
            if (Number.isInteger(selectedIndex) && packages?.[selectedIndex]) {
                return packages[selectedIndex];
            }
        }

        const inputs = Array.from(
            document.getElementsByName(`button-group-item-MT_${maintenanceCode}`)
        );
        const checkedIndex = inputs.findIndex((input) => input.checked);

        return checkedIndex >= 0 ? packages?.[checkedIndex] : undefined;
    };

    const GetItem = (Paq) => {
        if (Paq?.Aportacion?.NumeroCuotasAportacion > 0)
            return {
                value: String(Paq.Key),
                buttonLabel: "Seleccionar",
                description: (
                    <>
                        <span className="u-mb-none u-text-center" style={{ display: "block" }}>
                            <span className="u-font-size-fs0">
                                Durante los primeros {Paq?.Aportacion?.NumeroCuotasAportacion} meses:{" "}
                                {currencyFormat(Paq?.Aportacion?.ImporteDescuentoCuotasAportadas / 100)}
                                /mes
                            </span>
                            <br />
                            <span className="u-font-size-fs0">
                                Después <b>{currencyFormat(Paq?.Servicio?.ImporteBrutoTarifa / 100)}</b>
                                /mes
                            </span>
                            <br />
                            {getIVAText(locationVehicle?.IsCanarias, "IVA Incluido")}
                        </span>
                    </>
                ),
                discountOldPrice: currencyFormat(Paq?.Servicio?.ImporteBrutoTarifa / 100),
                price: (
                    <h4 className="u-text-center u-m-none">
                        {currencyFormat(Paq?.Aportacion?.ImporteDescuentoCuotasAportadas / 100)}
                    </h4>
                ),
                pricingHeader: "Cuota Mensual",
                title: `< ${financialFormat(Paq.Key, 0)} km/año`,
            };
        else
            return {
                value: String(Paq.Key),
                buttonLabel: "Seleccionar",
                description: (
                    <>
                        <span className="u-mb-none u-text-center" style={{ display: "block" }}>{getIVAText(locationVehicle?.IsCanarias, "IVA Incluido")}</span>
                    </>
                ),
                price: (
                    <h4 className="u-text-center u-m-none">
                        {currencyFormat(Paq?.Servicio?.ImporteBrutoTarifa / 100)}
                    </h4>
                ),
                pricingHeader: "Cuota Mensual",
                title: `< ${financialFormat(Paq.Key, 0)} km/año`,
            };
    };

    useEffect(() => {
        dispatch(setMantenimientoStandAlone(null));
        dispatch(setSelectedMantenimentoStandAlone(null));
        dispatch(getMantenimientoLDStandAlone(OutOfWindowAction.formOutOfWindow));
    }, []);

    return (
        <>
            {mantenimientoStandAlone?.length > 0 &&
                mantenimientoStandAlone[0]?.internalValue === "No existen aportaciones para el paquete actual" && (
                    <Layout.Item>
                        <p>No existen aportaciones para el paquete actual</p>
                    </Layout.Item>
                )}
            {mantenimientoStandAlone?.MantenimientoLD?.Mantenimientos?.map((MT, index) => (
                <Layout.Item key={"MT_" + MT.Codigo}>
                    {index > 0 && <hr className="u-mb" />}
                    <Layout>
                        <Layout.Item>
                            <Layout className="row" middle>
                                <Layout.Item default="3/5" m="1/1">
                                    <h4 className="u-text-left u-mb-none">{MT.Descripcion}</h4>
                                </Layout.Item>
                                <Layout.Item default="2/5" m="1/1">
                                    <div className="u-text-right">
                                        {validateMantenimientoIcon(MT.Codigo) && <SVGMantenimiento></SVGMantenimiento>}
                                        {validateDesgasteIcon(MT.Codigo) && (
                                            <span className="u-ml">
                                                <SVGDesgaste></SVGDesgaste>
                                            </span>
                                        )}
                                    </div>
                                </Layout.Item>
                            </Layout>
                        </Layout.Item>

                        <Layout.Item default="1/1" l="1/1">
                            <CompareAndSelect
                                inputGroup={`MT_${MT.Codigo}`}
                                label={{ text: "Paquetes de mantenimiento", isHidden: true }}
                                onChange={(eventOrValue, callbackValue) => {
                                    const selectedPackage = resolveSelectedPackage(
                                        MT.Paquetes,
                                        MT.Codigo,
                                        eventOrValue,
                                        callbackValue
                                    );
                                    setSelected(selectedPackage);
                                }}
                                items={MT.Paquetes?.map((Paq) => GetItem(Paq)) ?? []}
                            />
                            {/* </ButtonGroup> */}
                        </Layout.Item>
                        <MantenimientoStandAloneShowMore code={MT.Codigo} />
                    </Layout>
                </Layout.Item>
            ))}
        </>
    );
};
